// extracted by mini-css-extract-plugin
export default {"imageWrapper":"style_imageWrapper__CB7Ai","img":"style_img__YApoE"};